export var MessageMetadataType;
(function (MessageMetadataType) {
    MessageMetadataType["ToolConfiguration"] = "tool_configuration";
    MessageMetadataType["ToolActivation"] = "tool_activation";
    MessageMetadataType["ToolDeactivation"] = "tool_deactivation";
    MessageMetadataType["AgentBuilder"] = "agent_builder";
    MessageMetadataType["ConfigurationChange"] = "configuration_change";
    MessageMetadataType["StateCheckpoint"] = "state_checkpoint";
    MessageMetadataType["Revert"] = "revert";
    MessageMetadataType["DocChange"] = "doc_change";
    MessageMetadataType["Reasoning"] = "reasoning";
    MessageMetadataType["OpenAIAnnotations"] = "openai_annotations";
    MessageMetadataType["QuickReplies"] = "quick_replies";
    MessageMetadataType["MemoryCreated"] = "memory_created";
    MessageMetadataType["TaskCreated"] = "task_created";
    MessageMetadataType["TriggeredByTask"] = "triggered_by_task";
    MessageMetadataType["SystemError"] = "system_error";
    MessageMetadataType["Multiple"] = "multiple";
    MessageMetadataType["Ui"] = "ui";
    MessageMetadataType["PaywallPrompt"] = "paywall_prompt";
})(MessageMetadataType || (MessageMetadataType = {}));
//# sourceMappingURL=message-metadata-type.const.js.map